<template>
  <div>
    <van-tabs v-model="active" title-active-color="#007AFF" sticky>
      <van-tab title="心理咨询">
        <div class="zxbox">
          <div class="list">
            <p
              @click="pp(index, item.consultanttype)"
              :class="[{ acp: isshow == index }]"
              v-for="(item, index) in list"
              :key="index"
            >
              {{ item.typeName }}
            </p>
            <!-- <span
              @click="pp(index, item.consultanttype)"
              :class="[{ acp: isshow == index }]"
              v-for="(item, index) in list"
              :key="index"
            >
              {{ item.typeName }}
            </span> -->
          </div>

          <div class="item_all">
            <div
              class="item"
              @click="gozxDetails(item.userId)"
              v-for="(item, index) in rows"
              :key="index"
            >
              <div class="left">
                <div class="left-itmg">
                  <img :src="miXinGetImgUrl(item.url)" alt="" />
                </div>
              </div>
              <div class="right">
                <div class="one">
                  <p>姓名：{{ item.nickName }}</p>
                  <p>{{ item.online == "在线" ? "在线" : "" }}</p>
                </div>
                <div class="two">擅长：{{ item.remark }}</div>
                <div class="three">
                  <div style="display: flex; align-items: center">
                    <img src="../../assets/zx1.png" alt="" />
                    <p style="font-size: 0.8rem; color: #999">
                      {{ item.count }}人咨询过
                    </p>
                  </div>
				  <span @click.stop="goPhone(item)">打电话</span>
                  <span @click.stop="gofast(item.userId)">去咨询</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="大家在问">
        <div class="dajiabox">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="50"
          >
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
              <div
                @click="golist(item.id)"
                class="box"
                v-for="(item, index) in daros"
                :key="index"
              >
                <div class="box_top">
                  <div class="top_top">
                    <p>
                      {{ item.message }}
                    </p>
                  </div>
                </div>
                <div class="box_button">
                  <div style="display: flex; align-items: center">
                    <img
                      style="width: 20px; height: 20px"
                      :src="item.avatar"
                      alt=""
                      v-if="item.avatar"
                    />
                    <img
                      style="width: 20px; height: 20px"
                      src="../../assets/portrait.png"
                      alt=""
                      v-else
                    />
                    <p
                      style="color: #323332; font-size: 0.8rem; margin-left: 5px"
                    >
                      {{ item.nickName }}
                    </p>
                    <p
                      style="color: #007aff; font-size: 0.8rem; margin-left: 5px"
                    >
                      {{ item.isAnswer == 1 ? "已解答" : "未解答" }}
                    </p>
                  </div>
                  <p style="color: #999; font-size: 0.8rem;">
                    {{ item.createTime }}
                  </p>
                </div>
              </div>
            </van-pull-refresh>
          </van-list>

          <div class="fangkuai" @click="goAnswerProblem">
            <img src="../../assets/ques.png" alt="" />
            <p>我要提问</p>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="hezi"></div>
  </div>
</template>

<script>
import { getList, getdajiaList, tapList, ppUserid, addPhoneRecord } from "../../api/user";
import { Toast } from "vant";
import { login } from "@/api/login";
import axios from "axios";
let socket;
export default {
  data() {
    return {
      active: 0,
      isshow: 0,
      loading: false,
      finished: false,
      isLoading: false,
      list: [],
      pageJson: {
        pageNum: 1,
        pageSize: 10,
        consultantType: 0,
      },
      userIId: null,
      dajiaJson: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      rows: [], //心理咨询 数据
      daros: [], //大家再问 数据
    };
  },
  created() {
    this.getdata();
    this.getdajia();
    this.getlist();
    this.initWebSocket();
  },
  methods: {
    // zxDetails
    // goconsulting
	//电话
	goPhone(val){
		let data = {
			doctorId:val.userId,
		    doctorName:val.nickName
		}
		addPhoneRecord(data).then((res) => {
		  if(res.code == 200){
			if(labor.isApp()){
				labor.callPhone(val.phonenumber);
			}else{
				window.location.href = 'tel:'+ val.phonenumber;
			}
		  	
		  }
		});
	},
    gofast(id) {
      //去聊天
      axios({
        url: "/api/system/work/",
        method: "post",
        data: {
          userId: window.localStorage.getItem("userId"),
          doctorId: id,
          score: "",
          type: "1",
          isOpen: "0",
          isView: "0",
        },
      }).then((res) => {
        this.ids = res.data.data;
        window.sessionStorage.setItem("idall", res.data.data.id);
        this.miniJump(`/goconsulting?id=${id}`)
      });
    },
    gozxDetails(id) {
      this.miniJump(`/zxDetails?id=${id}`)
    },
    //聊天
    initWebSocket() {
      let userId = window.localStorage.getItem("userId");

      let _this = this;
      if (typeof WebSocket == "undefined") {
      } else {
        let socketUrl =
          "wss://websocket.qdszgh.cn:8443/sockxsj/websocket/message/" + userId;
        if (socket != null) {
          socket.close();
          socket = null;
        }
        // 开启一个websocket服务
        socket = new WebSocket(socketUrl);
        //打开事件
        socket.onopen = function () {
        };
        //  浏览器端收消息，获得从服务端发送过来的文本消息
        socket.onmessage = function (msg) {
          _this.userIId = msg.data;
        };
        //关闭事件
        socket.onclose = function () {
        };
        //发生了错误事件
        socket.onerror = function () {
        };
      }
    },
    //大家提问详情
    golist(id) {
      this.miniJump(`/consultDetail?id=${id}`)
    },
    //tap
    async getlist() {
      const res = await tapList();
      this.list = res.rows;
    },
    //我的提问
    goAnswerProblem() {
      this.miniJump(`/AnswerProblem`)
    },
    onRefresh() {
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;
        this.getdajia();
      }, 1000);
    },
    //大家再问
    async getdajia() {
      const res = await getdajiaList(this.dajiaJson);
      if (res.rows == null) {
        this.daros = [];
        this.finished = true; // 停止加载
      } else {
        this.daros.push(...res.rows);
        this.dajiaJson.total = res.total;
        this.loading = false;
        this.daros.length >= this.dajiaJson.total ? (this.finished = true) : "";
      }
    },
    onLoad() {
      this.dajiaJson.pageNum++;
      this.getdajia(this.dajiaJson);
    },
    //心理咨询
    async getdata() {
      const res = await getList(this.pageJson);
      this.rows = res.rows;
      this.pp(0, 0);
    },

    async pp(index, id) {
      this.isshow = index;
      const res = await ppUserid(id);
      this.rows = res.rows;
    },
  },
};
</script>

<style lang="scss" scoped>
.hezi {
  width: 100%;
  height: 55px;
  background: #fff;
}
.dajiabox {
  width: 100%;
  background: #f7f7f7;
  padding: 0 15px;

  .fangkuai {
    width: 68px;
    height: 68px;
    background: #fff;
    box-shadow: 0px 1px 8px 0px rgba(6, 35, 55, 0.25);
    border-radius: 8px;
    opacity: 1;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    bottom: 100px;
    right: 0;
    img {
      width: 26px;
      height: 26px;
    }
    p {
      font-size: 0.9rem;
      color: #007aff;
    }
  }
  .box {
    width: 100%;
    height: 107px;
    background: #fefffe;
    border-radius: 8px;
    opacity: 1;
    margin: auto;
    margin-top: 10px;
    .box_button {
      width: 100%;
      height: 50%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
    }
    .box_top {
      width: 100%;
      height: 50%;
      color: #323332;
      font-size: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .top_top {
        width: 90%;
        height: 90%;
        padding: 5px;
        p {
          font-weight: bolder;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          align-content: center;
        }
      }
    }
  }
}
.zxbox {
  width: 100%;
  background: #f7f7f7;
  padding: 0 3% 15px 3%;

  .item_all {
    background: #fff;
    padding: 10px;
    border-radius: 8px;
  }

  .item {
    width: 100%;
    height: 100px;
    background: transparent;
    border-radius: 8px 8px 0px 0px;
    opacity: 1;
    display: flex;
    margin: auto;
    margin-top: 15px;
    .right {
      width: 70%;
      height: 100%;
      .three {
        width: 100%;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0px;
        span {
          background: linear-gradient(180deg, #4EA3FF 0%, #007AFF 100%);
          border-radius: 15px 15px 15px 15px;
          opacity: 1;
          color: #ffffff;
          font-size: 0.75rem;
          padding: 6px 15px;
        }
      }
      .two {
        width: 100%;
        height: 38px;
        color: #323332;
        font-size: 0.95rem;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        align-content: center;
      }
      .one {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        p:first-child {
          color: #323332;
          font-size: 0.9rem;
        }
        p:last-child {
          height: 14px;
          border-radius: 2px;
          opacity: 1;
          color: #ffffff;
          background: #15bc84;
          font-size: 0.8rem;
          text-align: center;
          line-height: 14px;
          margin-left: 10px;
        }
      }
    }
    .left {
      width: 30%;
      height: 100%;
      display: flex;
      align-items: center;
      .left-itmg {
        width: 90%;
        height: 90%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
        }
      }
    }
  }
  .item:first-child {
    margin-top: 0;
  }
  .list {
    width: 100%;
    padding: 15px 0;
    background: #f7f7f7;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    p, .acp{
      text-align: center;
      padding: 11px 15px;
      display: inline-block;
      background: #fff;
      border-radius: 146px;
      margin-left: 6px;
      color: #323332;
      font-size: 0.9rem;
    }
    .acp {
      background: linear-gradient(180deg, #4ea3ff 0%, #007aff 100%);
      color: #fff;
    }
  }
  .list::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}

::v-deep .van-tabs__line {
  background-color: #007aff;
}
.top {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .incon {
    margin-left: -40px;
  }
}
</style>
